import Vue from 'vue';
import VueLuxon from "vue-luxon";
Vue.use(VueLuxon, {
    locale: 'en',
});
